﻿// Named useToasts to avoid conflict with useToast from Nuxt UI
export function useToasts() {
    const toast = useToast();

    const successToast = (title: string, description?: string) => {
        if (!import.meta.client) return undefined;

        return toast.add({
            title,
            description,
            icon: 'i-lucide-check',
            color: 'neutral',
            duration: 2000,
            progress: false,
        });
    };

    const errorToast = (title: string, description?: string) => {
        if (!import.meta.client) return undefined;

        return toast.add({
            title,
            description,
            icon: 'i-lucide-error',
            color: 'error',
            duration: 5000,
            progress: true,
        });
    };

    return {
        successToast,
        errorToast,
    };
}
